import React, { FunctionComponent } from 'react'
import NavBar from 'components/NavBar'
import Icon from 'components/UI/Icons'
import styled from 'styled-components'

interface Props {
    alt?: string
}

const StyledContainer = styled.div<Props>`
    height: ${(props) => (props.alt ? 'auto' : '450px')};
    overflow: auto;

    &::-webkit-scrollbar {
        width: 0px;
    }
`

const StyledHeader = styled.div`
    height: 358px;
    background-image: url('/img/header.png');
    background-position: center;
    background-size: cover;
    background-color: #eeeeee;
`

const DashboardLayout: FunctionComponent<Props> = ({ alt, children }) => {
    return (
        <div className={`${alt ? 'overflow-auto' : 'overflow-hidden'} relative h-screen`}>
            <div className='absolute top-0 right-0 mt-3 md:pt-1 md:pr-24 z-50'>
                <div className='flex items-center'>
                    <button
                        className={`flex h-12 items-center ${
                            alt ? 'bg-smoke-100-light' : 'bg-white-light mt-3'
                        } px-3 py-1 rounded-sm`}
                    >
                        <img src={require('assets/img/User.png')} alt='user' className='w-8' />
                        <p className={`${alt ? 'text-snow-200' : 'text-white'} text-sm pl-3`}>Admin</p>
                        <div className='w-3 ml-2'>
                            <Icon name='caret-down' />
                        </div>
                    </button>

                    <button
                        className={`flex h-12 items-center ${
                            alt ? 'bg-smoke-100-light' : 'bg-white-light mr-2 mt-3'
                        } px-4 py-1 rounded-sm ml-3`}
                    >
                        <Icon name='notification' className='w-4' />
                    </button>
                </div>
            </div>
            {!alt && (
                <StyledHeader className='relative'>
                    <div className='absolute top-0 h-full flex items-center w-10/12 inset-x-0 mx-auto'>
                        <div>
                            <img src={require('assets/logo.svg')} alt='logo' className='w-10' />
                            <div className='mt-4 md:mt-10 md:w-8/12 lg:w-7/12'>
                                <h1 className='text-dark text-4xl font-bold'>Core Banking System</h1>
                                <p className='tracking-xs text-dark opacity-50 text-lg lg:mt-2'>
                                    With our application, you can create your very own core banking system in minutes.
                                </p>
                                <div className='mt-4'>
                                    <button className='bg-green px-5 py-2 text-white rounded-xs text-xs'>
                                        Learn more
                                    </button>
                                </div>
                            </div>
                            <div className='flex items-center mt-6 md:mt-12'>
                                <div className='w-10 h-1 rounded-full bg-blue-dark mr-2'></div>
                                <div className='w-10 h-1 rounded-full bg-blue-dark opacity-25 mr-2'></div>
                                <div className='w-10 h-1 rounded-full bg-blue-dark opacity-25'></div>
                            </div>
                        </div>
                    </div>
                </StyledHeader>
            )}
            <div>
                <NavBar alt={alt} />
            </div>
            <StyledContainer alt={alt}>{children}</StyledContainer>
        </div>
    )
}

export default DashboardLayout
